/**
 * Tres Commas raw flow — GET/PUT /tres-commas/flows/:id/raw. Same Voluum
 * flow shape and the same PUT pipeline as Voluum's (strip TrafficPulse keys,
 * normalize paths, validate before anything leaves the browser). The backend
 * write guard refuses (403) unless writes are on for this flow.
 * For Media Devoted | Created By Ciro Autiero
 */

import api from '@/services/api';
import { prepareRawFlowPut } from '@/features/flow-optimizer/services/voluum-flow-api';
import type { VoluumFlowResource, VoluumFlowUpdate } from '@trafficpulse/shared';

const BASE = '/tres-commas/flows';

export async function getTresCommasRawFlow(flowId: string): Promise<VoluumFlowResource> {
  const { data } = await api.get(`${BASE}/${flowId}/raw`);
  return (data.data ?? data) as VoluumFlowResource;
}

export async function updateTresCommasRawFlow(
  flowId: string,
  body: VoluumFlowUpdate,
): Promise<{ success: boolean; flow: VoluumFlowResource }> {
  const payload = prepareRawFlowPut(body);
  const { data } = await api.put(`${BASE}/${flowId}/raw`, payload);
  return (data.data ?? data) as { success: boolean; flow: VoluumFlowResource };
}
